"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var SUPPORTED_FIELDS = ['select', 'radio', 'booleancheckbox', 'checkbox', 'text', 'textarea', 'number'];
var TEXT_FIELD_TYPES = ['text', 'textarea'];
var SUPPORTED_TEXT_TYPES = ['string']; // nonsupported types include datetime, number

var isSupportedPropertyType = (0, _memoize.default)(function (property) {
  if (!property || property.get('hidden') || property.get('readOnlyValue') || property.get('externalOptions')) {
    return false;
  }

  var fieldType = property.get('fieldType');

  if (TEXT_FIELD_TYPES.indexOf(fieldType) > -1) {
    var type = property.get('type');
    return SUPPORTED_TEXT_TYPES.indexOf(type) > -1;
  }

  return SUPPORTED_FIELDS.indexOf(fieldType) > -1;
});
var _default = isSupportedPropertyType;
exports.default = _default;
module.exports = exports.default;